export default function px2jspx(px) {
  const rate = document.documentElement.clientWidth / 375;
  return parseFloat(px) * rate;
}



// WEBPACK FOOTER //
// ./src/assets/js/px2jspx.js